import { render, staticRenderFns } from "./AssignmentSubmissionReview.vue?vue&type=template&id=3f463e08"
import script from "./AssignmentSubmissionReview.vue?vue&type=script&lang=js"
export * from "./AssignmentSubmissionReview.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSubmissionReview.vue?vue&type=style&index=0&id=3f463e08&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports